import styled from 'styled-components';

import { Box, ButtonSmallPrimary, ButtonText, LabelBold, LabelRegular } from '@comeon/ui';

export const StyledBox = styled(Box)`
	display: flex;
	flex-direction: column;
`;

export const StyledContainer = styled(StyledBox)`
	position: absolute;
	bottom: 0;
	top: 0;
	width: 100%;
	left: 0;
	background: var(--sidebar-bg, rgba(var(--base-11), 1));
	z-index: 7;
`;

export const StyledContent = styled(StyledBox)`
	flex: 1;
	justify-content: space-between;
	overflow: hidden;

	svg {
		fill: var(--section-head-main-icon);
		object-fit: fill;
		height: 56px;
		margin: 0 auto;
		width: 56px;
	}
`;

export const StyledScrollContainer = styled(StyledBox)`
	flex: 1;
	overflow: auto;
	scrollbar-width: none;
	scroll-snap-type: y mandatory;
	-webkit-overflow-scrolling: touch;
	-ms-overflow-style: none;
`;

const StyledListItem = styled(Box)`
	padding: 12px;
	display: flex;
	justify-content: space-between;
	background-color: var(--link-list);
`;

export const StyledUploadList = styled(StyledListItem)`
	padding: 12px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	top: 0;
	position: sticky;
`;

export const StyledDocument = styled(StyledListItem)<{ $animate: boolean }>`
	@keyframes load-right {
		0% {
			left: -100%;
		}
		50% {
			left: 0;
		}
		100% {
			left: 100%;
		}
	}

	align-items: flex-end;
	border-bottom: 1px solid var(--list-border-bottom);
	margin-bottom: 12px;
	position: relative;
	gap: 15px;
	overflow: hidden;

	${({ $animate }) => $animate && 'animation: 1000ms ease 0ms 1 normal none running pop-up;'}

	&:after {
		content: '';
		position: absolute;
		width: 100%;
		bottom: -1px;
		height: 3px;
		animation-iteration-count: 2;
		left: -100%;

		${({ $animate }) =>
			$animate &&
			`
				animation: load-right 2s 1s cubic-bezier(0.645, 0.045, 0.355, 1) forwards;
				background-color: rgba(var(--font-brand-01), 1);
			`}
	}
`;

export const StyledInput = styled.input`
	display: none;
`;

export const StyledDocumentContainer = styled(StyledBox)`
	padding: 12px;
	flex: 1;
`;

export const StyledInnerContainer = styled(Box)`
	border-radius: 3px;
	padding: 0 12px;
	background-color: var(--link-list);
`;

export const StyledUploadButton = styled(ButtonSmallPrimary)`
	text-transform: none;
	padding: 8px 12px;
	position: relative;
`;

export const StyledButtonContainer = styled(StyledBox)`
	justify-content: space-between;
	padding: 10px 18px;
	align-items: center;

	.contact-btn {
		color: rgba(var(--primary), 1);
	}
`;

export const StyledContactSupport = styled.div`
	display: inline-flex;
	align-items: center;
	font-size: 14px;
	padding: 10px 18px;
`;

export const StyledOrText = styled.span`
	margin-right: 5px;
`;

export const StyledLinkButton = styled(ButtonText)`
	font-size: 14px;
	color: rgba(var(--primary), 1);
	text-decoration: underline;
`;

export const StyledLabel = styled(LabelRegular)`
	flex-shrink: 0;
	color: rgba(var(--font-supportive), 1);
`;

export const StyledFileName = styled(LabelBold)`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
